import {FocusScope} from '@react-aria/focus';

import {useCopyToClipboardStateful} from '../../../../../hooks/copy-to-clipboard';
import {CheckCircleIcon} from '../../../../../icons/check-circle';
import {ContentCopy} from '../../../../../icons/content-copy';
import {CloseIcon} from '../../../../../icons/close';
import {BUTTON_SIZE, IconButton} from '../../../../icon-button';

import styles from './styles.module.css';

export function CopyBtn(props: { value: string }) {
    // @TODO: Вынести это на уровень списка, чтобы можно было вызывать копирование
    // и показ состояния при фокусе. На текущий момент не критично
    const {handleCopy, init, successful, failed} = useCopyToClipboardStateful(props.value);

    let icon = <ContentCopy />;

    if (init) {
        icon = <ContentCopy />;
    }

    if (successful) {
        icon = <CheckCircleIcon />;
    }

    if (failed) {
        icon = <CloseIcon />;
    }

    return (
        <div className={styles.copyBtn}>
            <FocusScope contain={true}>
                <IconButton
                    data-testid='copy-btn'
                    size={BUTTON_SIZE.XSMALL}
                    flat={init}
                    destructive={failed}
                    inverted={successful || failed}
                    icon={icon}
                    onPress={handleCopy}
                />
            </FocusScope>
        </div>
    );
}
